

import { chooseObj, inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  inputObj('姓名', "FNAME", true, true),
  inputObj('证件号码', "FIDNUM", true, true),
  inputObj('性别', "FSEX", true, true),
  inputObj('手机号码', "FPHONUM", true),
  inputObj('电子邮箱', "FEMAIL", true),
  pickerObj('常住地址', 'address', true, true),
  {
    ...chooseObj('申领类型', 'FCLAIMTYPE', true),
    option: [[
      { label: '纸质', value: 0 },
      { label: '电子', value: 1 },
      { label: '两者都申请', value: 2 }
    ]]
  },
  inputObj('邮寄地址', "FMAILADDRESS", true),
];

export const applyCertificatePage1 = [
  { title: '基本信息', arr: basicInformation },
]

